<template>
  <div class="page-overlay">
    <div class="page-overlay-container" :class="{ active: active, open: isOpen, animate: !dragging, 'stop-scroll': dragging }">
      <div class="drag-arrow black" :class="{active: dragging}"><span class="line line-1"></span><span class="line line-2"></span></div>

      <div class="page-overlay-content">
        <h4>Accessibilty</h4>
        <p>Details for this location</p>
        <ul v-if="artist" class="a11y">
          <li v-if="artist.a11y_parking.length && !artist.a11y_parking.includes('None of the above')"><i>Parking:</i> {{artist.a11y_parking.join(', ')}}</li>
          <li v-if="artist.a11y_mobility.length && !artist.a11y_mobility.includes('None of the above')"><i>Mobility:</i> {{artist.a11y_mobility.join(', ')}}</li>
          <li v-if="artist.a11y_restrooms.length && !artist.a11y_restrooms.includes('None of the above')"><i>Restrooms:</i> {{artist.a11y_restrooms.join(', ')}}</li>
          <li v-if="artist.a11y_other.length && !artist.a11y_other.includes('None of the above')">{{artist.a11y_other.join(', ')}}</li>
          <li v-if="artist.a11y_family !== 'No'">{{artist.a11y_family.replace('Yes, ', '')}}</li>
        </ul>
      </div>
    </div>
    <div class="page-overlay-backdrop" :class="{ open: isOpen, closing: isClosing }" @click="close"></div>
  </div>
</template>

<script>
import PageOverlay from "../../mixins/PageOverlay";

export default {
  props: ["artist"],
  mixins: [PageOverlay],
  computed: {
    ada() {
      return this.artist.acf.ada.split(', ');
    },
  },
};
</script>

<style scoped lang="less">
@import '../../css/variables';

h4 {
  font-size: 20px;
  font-weight: 600;
}
p {
  font-size: 16px;
  font-weight: 300;
}
ul {
  margin: 25px -15px 0 0;
  li {
    padding: 10px 15px 10px 0;
    font-size: 16px;
    font-weight: 300;
    border-bottom: .5px solid #e4e5e5;
    &:first-child {
      border-top: .5px solid #e4e5e5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Artist/ADA.vue